/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  .mock-phone {
    width: 412px;
    height: ${props => props.isFixed ? 'calc(100vh - 100px)' : '816px'};
    max-height: ${props => props.isFixed ? 'calc(100vh - 100px)' : '816px'};
    position: relative;
    border: 18px solid #3d3b48;
    border-radius: 50px;
    padding: 40px 0 72px;
    background-color: #f1efe9;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .mock-status-bar {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    border-radius: 50px 50px 0 0;
  }
  .mock-header {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    position: relative;
    flex-shrink: 0;
  }
  .mock-back {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 20px;
  }
  .mock-children {
    overflow: ${props => props.isFixed ? 'auto' : 'hidden'};
    overflow-x: hidden;
    flex: 1;
    min-height: 0;
    padding: 0 20px;
    /* 确保滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
  .mock-tabbar {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    border-radius: 0 0 30px 30px;
    width: 100%;
    flex-shrink: 0;
  }
`;
